var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1232,
    height: 816,
    viewBox: "0 0 1232 816",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_3254)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_93_3254",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1232,
    height: 816
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1192 0H40C17.9086 0 0 17.9086 0 40V776C0 798.091 17.9086 816 40 816H1192C1214.09 816 1232 798.091 1232 776V40C1232 17.9086 1214.09 0 1192 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_93_3254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1192 0H40C17.9086 0 0 17.9086 0 40V776C0 798.091 17.9086 816 40 816H1192C1214.09 816 1232 798.091 1232 776V40C1232 17.9086 1214.09 0 1192 0Z",
    fill: "#23245A",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.72
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-27.9999 67.1104H1257.58",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.9999 135.732H1257.58",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.9999 204.353H1257.58",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.9999 272.975H1257.58",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.9999 341.595H1257.58",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.9999 410.216H1257.58",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.9999 478.838H1257.58",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.9999 547.459H1257.58",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.9999 616.081H1257.58",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.9999 684.7H1257.58",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.9999 753.322H1257.58",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.235 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.34 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.447 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3717 -52L66.3716 940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.992 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.613 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.855 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.479 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.097 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.721 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.96 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.583 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.204 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.827 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.07 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.69 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.31 -52V940.863",
    stroke: "#4A70C5",
    strokeOpacity: 0.3,
    strokeWidth: 1.07221
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.032 134.454H202.826V204.635H272.032V134.454Z",
    fill: "#527BD9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.827 66.2229H133.621V134.454H202.827V66.2229Z",
    fill: "#527BD9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.595 67.1978H65.3894V135.429H134.595V67.1978Z",
    fill: "#527BD9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.827 134.454H133.621V204.635H202.827V134.454Z",
    fill: "#527BD9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.702 -1.0083H409.496V67.223H478.702V-1.0083Z",
    fill: "#527BD9",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.057 271.892H203.826V341.098H272.057V271.892Z",
    fill: "#527BD9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.71 616.972H1027.48V685.203H1095.71V616.972Z",
    fill: "#527BD9",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.94 685.204H1095.71V753.435H1163.94V685.204Z",
    fill: "#527BD9",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.602 207.635H411.371V274.892H479.602V207.635Z",
    fill: "#527BD9",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.5 204.635H958.27V271.892H1026.5V204.635Z",
    fill: "#527BD9",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.71 204.635H1027.48V271.892H1095.71V204.635Z",
    fill: "#527BD9",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.5 273.866H958.27V341.123H1026.5V273.866Z",
    fill: "#527BD9",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.602 413.261H411.371V480.518H479.602V413.261Z",
    fill: "#527BD9",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.958 413.261H479.727V480.518H547.958V413.261Z",
    fill: "#527BD9",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.056 615.972H203.825V684.203H272.056V615.972Z",
    fill: "#527BD9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.495 685.204H341.264V753.435H409.495V685.204Z",
    fill: "#527BD9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.725 685H409.494V753.231H477.725V685Z",
    fill: "#527BD9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.831 685.204H752.6V753.435H820.831V685.204Z",
    fill: "#527BD9",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.495 753.435H341.264V822.641H409.495V753.435Z",
    fill: "#527BD9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.034 376.639H545.803V444.258H614.034V376.639Z",
    fill: "#527BD9",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.034 444.897H545.803V512.96H614.034V444.897Z",
    fill: "#527BD9",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.011 445.262H614.78V513.493H683.011V445.262Z",
    fill: "#527BD9",
    fillOpacity: 0.15
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1258 -52H-28V941H1258V-52Z",
    fill: "url(#paint0_radial_93_3254)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M1334 -102H703V529H1334V-102Z",
    fill: "url(#paint1_linear_93_3254)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M-104 920L527 920L527 289L-104 289L-104 920Z",
    fill: "url(#paint2_linear_93_3254)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_93_3254",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(646.5 445) rotate(-180) scale(598.5 1074.36)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEF2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_93_3254",
    x1: 996,
    y1: 241.5,
    x2: 1567,
    y2: -212.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEF2",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6277FF",
    stopOpacity: 0.52
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_93_3254",
    x1: 234,
    y1: 576.5,
    x2: -337,
    y2: 1030.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEF2",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6277FF",
    stopOpacity: 0.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_3254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1232,
    height: 816,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login-bg.fead8bf5df9d05e832875bb24daa7d15.svg";
export { ForwardRef as ReactComponent };